import { ColorType } from '@/theme/colors';
import { Temper } from '@/types/frontend-types';

export const MESSAGE_MODAL_VARIANT = {
  Global: 'global',
  Inline: 'inline',
} as const;

export type MessageModalVariant =
  typeof MESSAGE_MODAL_VARIANT[keyof typeof MESSAGE_MODAL_VARIANT];

export const CMESSAGEMODAL_SEQ_COMPONENT = 'Cmessagemodal';
export const SCROLL_DIMENSIONS_MARKER_NAME = 'scroll-dimensions';
export const SCROLL_DIRECTION_VERTICAL = 'vertical';
export const TEXT_ALIGN_CENTER = 'center';
export const MESSAGE_MODAL_CONTENT_DESKTOP_HEIGHT = '400px';
export const MESSAGE_MODAL_FOOTER_GLOBAL_FLEX_DIRECTION = 'row';
export const MESSAGE_MODAL_FOOTER_INLINE_FLEX_DIRECTION = 'column';
export const MESSAGE_MODAL_BACKDROP_FADE_DURATION_SECONDS = 0.35;
export const MESSAGE_MODAL_ENTRANCE_DURATION_SECONDS = 0.74;
export const MESSAGE_MODAL_EXIT_DURATION_SECONDS = 0.26;
export const MESSAGE_MODAL_BACKDROP_BLUR_PX = 10;
export const MESSAGE_MODAL_SURFACE_RADIUS_PX = 44;
export const MESSAGE_MODAL_SURFACE_GAP = '26px';
export const MESSAGE_MODAL_SURFACE_BACKGROUND = 'rgba(12, 17, 15, 0.66)';
export const MESSAGE_MODAL_SURFACE_BORDER_OPACITY = 0.08;
export const MESSAGE_MODAL_SURFACE_DESKTOP_PADDING = '38px 36px';
export const MESSAGE_MODAL_GLOW_PULSE_DURATION_SECONDS = 4;
export const MESSAGE_MODAL_GLOW_PULSE_MIN = 0.7;
export const MESSAGE_MODAL_GLOW_PULSE_MAX = 1.3;
export const MESSAGE_MODAL_GLOW_BASE_INTENSITY = 1;
export const MESSAGE_MODAL_SURFACE_MOBILE_HEIGHT = '100%';
export const MESSAGE_MODAL_SURFACE_MOBILE_JUSTIFY_CONTENT = 'center';
export const MOBILE_SURFACE_PADDING = '28px 24px max(54px, calc(34px + env(safe-area-inset-bottom)))';
export const MOBILE_FOOTER_PADDING_BOTTOM = 'max(14px, env(safe-area-inset-bottom))';
export const MOBILE_FOOTER_BUTTON_PADDING = '14px 24px';
export const MOBILE_FOOTER_BUTTON_HEIGHT = 46;
export const MOBILE_SINGLE_FOOTER_BUTTON_MAX_WIDTH = '280px';
export const MOBILE_CONTENT_MAX_HEIGHT = '35vh';

export const TRIANGLE_IMAGES: Record<Temper, string> = {
  [Temper.Good]: '/triangles/good.png',
  [Temper.Neutral]: '/triangles/neutral.png',
  [Temper.Bad]: '/triangles/bad.png',
  [Temper.Warn]: '/triangles/bad.png',
};

export const MESSAGE_MODAL_ACCENT_COLOR_BY_TEMPER: Record<Temper, ColorType> = {
  [Temper.Good]: ColorType.Accent,
  [Temper.Neutral]: ColorType.White,
  [Temper.Bad]: ColorType.Danger,
  [Temper.Warn]: ColorType.Warn,
};

const FULL_PULSE_ROTATION_RADIANS = Math.PI * 2;
const THROB_PULSE_SAMPLE_COUNT = 8;

export const MESSAGE_MODAL_GLOW_PULSE_TIMES: number[] = Array.from(
  { length: THROB_PULSE_SAMPLE_COUNT + 1 },
  (_, sampleIndex) => sampleIndex / THROB_PULSE_SAMPLE_COUNT,
);

export const MESSAGE_MODAL_GLOW_PULSE_FACTORS: number[] =
  MESSAGE_MODAL_GLOW_PULSE_TIMES.map((phase) => {
    const sine = 0.5 - 0.5 * Math.cos(phase * FULL_PULSE_ROTATION_RADIANS);
    const throb = sine * sine;

    return MESSAGE_MODAL_GLOW_PULSE_MIN
      + (MESSAGE_MODAL_GLOW_PULSE_MAX - MESSAGE_MODAL_GLOW_PULSE_MIN) * throb;
  });

export const MESSAGE_MODAL_GLOW_PULSE_OPACITIES: number[] =
  MESSAGE_MODAL_GLOW_PULSE_FACTORS.map(
    (factor) => factor / MESSAGE_MODAL_GLOW_PULSE_MAX,
  );

export const MESSAGE_MODAL_GLOW_REDUCED_MOTION_OPACITY =
  MESSAGE_MODAL_GLOW_BASE_INTENSITY / MESSAGE_MODAL_GLOW_PULSE_MAX;
